import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { reducer as formReducer } from 'redux-form'

import entities from './entities'
import errorMessage from './error-message'
import pages from './pages'
import pagination from './pagination'
import settings from './settings'
import cropper from './cropper'
import navigation from './navigation'
import draftDeals from './draft-deals'
import draftEventGroup from './draft/eventgroup'
import grid from './grid'

const rootReducer = combineReducers({
  routing: routerReducer,
  entities,
  error: errorMessage,
  pages,
  pagination,
  settings,
  cropper,
  navigation,
  draftDeals,
  draftEventGroup,
  form: formReducer,
  grid,
})

export default rootReducer



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/